// import React, { useEffect, useState, useCallback } from "react";
// import {
//     flexRender,
//     getCoreRowModel,
//     getSortedRowModel,
//     useReactTable,
//     getFilteredRowModel,
// } from "@tanstack/react-table";
// import { useVirtualizer } from "@tanstack/react-virtual";
// import { DebouncedInput, IndeterminateCheckbox } from "./Filters";
// import { ArrowDownCircleIcon, ArrowDownTrayIcon, EyeIcon, FolderArrowDownIcon } from "@heroicons/react/24/outline";
// import ReadModal from "./ReadModal";
// import JSZip from 'jszip';
// import { generateFileNameDated, generateProcessCodeFileName } from "./CommonUtils";

// export default function Process({ startProcess, selectedFilesToProcess }) {
//     let [isOpenRead, setIsOpenRead] = useState(false);
//     let [rowData, setRowData] = useState([]);
//     let [modalTitle, setModalTitle] = useState(false);
//     const [data, setData] = useState([]);

//     useEffect(() => {
//         setData(selectedFilesToProcess);
//     }, [selectedFilesToProcess]);

//     useEffect(() => {
//         if (tableContainerRef.current) {
//             rowVirtualizer.measure(); // ✅ THIS IS THE KEY
//         }
//         }, [rows.length, rowVirtualizer]);

//     function closeReadModal() {
//         setIsOpenRead(false);
//     }

//     function openReadModal(e) {
//         setRowData(e);
//         setModalTitle(`Response of ${e.filename}`);
//         setIsOpenRead(true);
//     }
//     const formattedDate = useCallback((dateStr) => {
//         const date = new Date(dateStr);
//         const formattedDateString = date
//             .toLocaleString("en-US", {
//                 day: "2-digit",
//                 month: "2-digit",
//                 year: "numeric",
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 second: "2-digit",
//                 hour12: false,
//             })
//             .replace(/\//g, "/")
//             .replace(",", " ");
//         const [month, day, yearAndTime] = formattedDateString.split("/");
//         return `${day}-${month}-${yearAndTime}`;
//     }, []);

//     const [sorting, setSorting] = React.useState([]);
//     const [globalFilter, setGlobalFilter] = React.useState('');
//     const [rowSelection, setRowSelection] = React.useState({});

//     const downloadFiles = useCallback(async () => {
//         const zip = new JSZip();

//         // Add each JSON file to the zip
//         const selectedProcessedFiles = Object.keys(rowSelection).filter((index) => rowSelection[index]).map((index) => data[index]);
//         if (selectedProcessedFiles.length > 0) {
//             selectedProcessedFiles.forEach((file) => {
//                 if (file.response) {
//                     const content = JSON.stringify(file.response);
//                     zip.file(`${generateFileNameDated(file.filename, file.creation_date)}.json`, content);
//                 }
//             });
//         }
//         else {
//             selectedFilesToProcess.forEach((file) => {
//                 if (file.response && file.response) {
//                     const content = JSON.stringify(file.response);
//                     zip.file(`${generateFileNameDated(file.filename, file.creation_date)}.json`, content);
//                 }
//             });
//         }

//         // Generate the zip file
//         const zipContent = await zip.generateAsync({ type: "blob" });

//         // Create a download link and trigger the download
//         const downloadLink = document.createElement("a");
//         downloadLink.href = URL.createObjectURL(zipContent);
//         downloadLink.download = `${sessionStorage.getItem("processName")}_${sessionStorage.getItem("projectName")}.zip`;
//         downloadLink.click();
//     }, [selectedFilesToProcess, data, rowSelection]);

//     const TextDownloadButton = ({ disabled, content, fileName }) => {
//         const downloadTxt = () => {
//             const blob = new Blob([JSON.stringify(content)], { type: 'text/plain' });
//             const link = document.createElement('a');
//             link.href = window.URL.createObjectURL(blob);
//             link.download = fileName + '.txt';
//             link.click();
//         };

//         return (
//             <button className="p-1 rounded-md border disabled:text-gray-300" disabled={disabled} onClick={downloadTxt}>
//                 <p className="flex gap-1" title="txt file download">
//                     <ArrowDownTrayIcon className="h-5" />
//                 </p>
//             </button>
//         );
//     };

//     const JsonDownloadButton = ({ disabled, content, fileName }) => {
//         const downloadJson = () => {
//             const blob = new Blob([JSON.stringify(content)], { type: 'application/json' });
//             const link = document.createElement("a");
//             link.href = window.URL.createObjectURL(blob);
//             link.download = fileName + ".json";
//             link.click();
//         };

//         return (
//             <button
//                 className="p-1 rounded-md border disabled:text-gray-300"
//                 disabled={disabled}
//                 onClick={downloadJson}
//             >
//                 <p className="flex gap-1" title="json file download">
//                     <ArrowDownCircleIcon className="h-5" />
//                 </p>
//             </button>
//         );
//     };

//     const columns = React.useMemo(
//         () => [
//             {
//                 id: "select",
//                 size: 10,
//                 header: ({ table }) => (
//                     <IndeterminateCheckbox
//                         {...{
//                             checked: table.getIsAllRowsSelected(),
//                             indeterminate: table.getIsSomeRowsSelected(),
//                             onChange: table.getToggleAllRowsSelectedHandler(),
//                         }}
//                     />
//                 ),
//                 cell: ({ row }) => (
//                     <center className="px-1">
//                         <IndeterminateCheckbox
//                             {...{
//                                 checked: row.getIsSelected(),
//                                 disabled: !row.getCanSelect(),
//                                 indeterminate: row.getIsSomeSelected(),
//                                 onChange: row.getToggleSelectedHandler(),
//                             }}
//                         />
//                     </center>
//                 ),
//             },
//             {
//                 accessorKey: 'index',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 size: 50,
//                 header: '#',
//                 cell: ({ row }) => <center>{row.index + 1}</center>,
//             },
//             // {
//             //     accessorKey: "filename",
//             //     enableColumnFilter: false,
//             //     size: 1000,
//             //     header: () => <span>File Name</span>,
//             //     // ✅ Add a cell renderer to handle multiple property names
//             //     cell: ({ row }) => (
//             //         <div>{row.original.filename || row.original.file_name || row.original.name || '-'}</div>
//             //     ),
//             // },
//             {
//                 id: "filename",
//                 accessorFn: (row) => row.filename || row.file_name || row.name || '-',
//                 enableColumnFilter: false,
//                 size: 1000,
//                 header: () => <span>File Name</span>,
//             },
//             {
//                 accessorKey: "start_date_time",
//                 enableColumnFilter: false,
//                 size: 100,
//                 header: "Start Date",
//                 cell: ({ row }) => <div>{row.original.start_date_time}</div>,
//             },
//             {
//                 accessorKey: "creation_date",
//                 enableColumnFilter: false,
//                 size: 100,
//                 header: "Execution Date",
//                 cell: ({ row }) => (
//                     <div>{row.original.creation_date !== "" && formattedDate(row.original.creation_date)}</div>
//                 ),
//             },
//             {
//                 accessorKey: "status",
//                 header: "Status",
//                 size: 50,
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: ({ row }) => (
//                     <div className="flex justify-center">
//                         <div
//                             className={`${row.original.status === "success" &&
//                                 "bg-green-500"
//                                 } ${row.original.status === "error" && "bg-red-500"
//                                 } ${row.original.status === "Inprogress" &&
//                                 "bg-blue-500"
//                                 }  ${row.original.status !== "success" &&
//                                 row.original.status !== "error" &&
//                                 row.original.status !== "Inprogress" &&
//                                 "bg-yellow-500"
//                                 } 
//                             text-white text-xs w-fit px-2 py-1 font-bold rounded-xl flex flex-nowrap`}
//                         >
//                             {row.original.status === 'Inprogress' && <div className="h-3 w-3 border-t-transparent border-solid animate-spin rounded-full border-white border-2 me-1 mt-0.5"></div>}
//                             {row.original.status && row.original.status}
//                             {!row.original.status && "Waiting"}
//                             {row.original.status === 'Inprogress' && '...'}
//                         </div>
//                     </div>
//                 ),
//             },
//             {
//                 accessorKey: "id",
//                 header: "Actions",
//                 size: 50,
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: ({ row }) => (
//                     <div className="flex gap-2 items-center justify-center">
//                         <TextDownloadButton disabled={row.original.response ? false : true} content={row.original.response} fileName={generateProcessCodeFileName(row.original.filename, row.original.creation_date)} />
//                         <JsonDownloadButton
//                             disabled={row.original.response ? false : true}
//                             content={row.original.response}
//                             fileName={generateProcessCodeFileName(row.original.filename, row.original.creation_date)}
//                         />
//                         <button
//                             className="p-1 rounded-md border text-green-600 disabled:text-gray-300"
//                             disabled={row.original.response ? false : true}
//                             onClick={() => openReadModal(row.original)}
//                         >
//                             <EyeIcon className="h-5" title="View Response" />
//                         </button>
//                     </div>
//                 ),
//             },
//         ],
//         [formattedDate]
//     );

//     const table = useReactTable({
//         data,
//         columns,
//         state: {
//             rowSelection,
//             sorting,
//             globalFilter
//         },
//         enableRowSelection: true,
//         onRowSelectionChange: setRowSelection,
//         onGlobalFilterChange: setGlobalFilter,
//         onSortingChange: setSorting,
//         getCoreRowModel: getCoreRowModel(),
//         getSortedRowModel: getSortedRowModel(),
//         getFilteredRowModel: getFilteredRowModel()
//     });

//     // const tableContainerRef = React.useRef(null);
//     function Filter({ column }) {
//         const columnFilterValue = column.getFilterValue();

//         return (
//             <input
//                 type="text"
//                 value={columnFilterValue || ""}
//                 onChange={(e) => column.setFilterValue(e.target.value)}
//                 placeholder={`Search...`}
//                 className="w-full border rounded-md text-xs"
//             />
//         );
//     }

//     const { rows } = table.getRowModel();
//     // const parentRef = useRef(null);
//     const tableContainerRef = React.useRef(null);

//     const rowVirtualizer = useVirtualizer({
//         count: rows.length,
//         // getScrollElement: () => parentRef.current, 
//         getScrollElement: () => tableContainerRef.current,  // ✅ ALWAYS a function
//         estimateSize: () => 45,
//     });

//     // const rowVirtualizer = useVirtualizer({
//     //     parentRef: tableContainerRef,
//     //     size: rows.length,
//     //     overscan: data.length,
//     // });
//     // const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

//     // const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
//     // const paddingBottom =
//     //     virtualRows.length > 0
//     //         ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
//     //         : 0;

//     const { virtualItems: virtualRows, totalSize } = rowVirtualizer;
//     const safeVirtualRows = virtualRows ?? [];

//     const paddingTop = safeVirtualRows.length > 0 ? safeVirtualRows[0]?.start || 0 : 0;
//     const paddingBottom =
//         safeVirtualRows.length > 0
//             ? totalSize - (safeVirtualRows[safeVirtualRows.length - 1]?.end || 0)
//             : 0;


//     return (
//         <div className="m-2 border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
//             <ReadModal
//                 isOpen={isOpenRead}
//                 closeModal={closeReadModal}
//                 title={modalTitle}
//                 modalInputs={
//                     <div className="overflow-auto h-[calc(100vh-8rem)] md:h-[calc(100vh-8rem)]">
//                         <pre className="pretxtwrap text-sm">
//                             {JSON.stringify(
//                                 rowData.response,
//                                 null,
//                                 2
//                             )}
//                         </pre>
//                     </div>
//                 }
//             />
//             {selectedFilesToProcess.length === 0 && (
//                 <p className="px-3 py-4">
//                     Please Start Process to process files
//                 </p>
//             )}
//             {selectedFilesToProcess.length > 0 && (
//                 <>
//                     <div className='flex justify-between m-3 gap-2'>
//                         <DebouncedInput
//                             value={globalFilter ?? ''}
//                             onChange={value => setGlobalFilter(String(value))}
//                             placeholder="Search..."
//                         />
//                     </div>
//                     <div ref={tableContainerRef} className="overflow-auto resp-processtable-h"  style={{ height: "60vh" }} >
//                         <table className="flex-inline w-full border-collapse">
//                             <thead className="bg-gray-200">
//                                 {table.getHeaderGroups().map((headerGroup) => (
//                                     <tr key={headerGroup.id}>
//                                         {headerGroup.headers.map((header) => {
//                                             return (
//                                                 <th
//                                                     className="border p-3 whitespace-nowrap"
//                                                     key={header.id}
//                                                     colSpan={header.colSpan}
//                                                     style={{
//                                                         width: header.getSize(),
//                                                     }}
//                                                 >
//                                                     {header.isPlaceholder ? null : (
//                                                         <>
//                                                             <div
//                                                                 className={`${header.column.getCanSort()
//                                                                         ? "cursor-pointer select-none justify-start"
//                                                                         : "justify-center"
//                                                                     } flex`}
//                                                                 onClick={header.column.getToggleSortingHandler()}
//                                                             >
//                                                                 {flexRender(
//                                                                     header.column
//                                                                         .columnDef
//                                                                         .header,
//                                                                     header.getContext()
//                                                                 )}
//                                                                 {{
//                                                                     asc: " 🔼",
//                                                                     desc: " 🔽",
//                                                                 }[
//                                                                     header.column.getIsSorted()
//                                                                 ] || null}
//                                                             </div>
//                                                             {header.column.getCanFilter() ? (
//                                                                 <div className="mt-2">
//                                                                     <Filter
//                                                                         column={
//                                                                             header.column
//                                                                         }
//                                                                         table={
//                                                                             table
//                                                                         }
//                                                                     />
//                                                                 </div>
//                                                             ) : null}
//                                                         </>
//                                                     )}
//                                                 </th>
//                                             );
//                                         })}
//                                     </tr>
//                                 ))}
//                             </thead>
//                             <tbody>
//                                 {
//                                     rows.length === 0 ?
//                                         (
//                                             <tr>
//                                                 <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
//                                                     No Data Found
//                                                 </td>
//                                             </tr>
//                                         )
//                                         :
//                                         (
//                                             <>
//                                                 {paddingTop > 0 && (
//                                                     <tr>
//                                                         <td
//                                                             className="border p-2"
//                                                             style={{ height: `${paddingTop}px` }}
//                                                         />
//                                                     </tr>
//                                                 )}
//                                                 {/* {virtualRows.map((virtualRow) => {
//                                                     const row = rows[virtualRow.index];
//                                                     return (
//                                                         <tr key={row.id} className="bg-white transition duration-300 ease-in-out hover:bg-gray-100">
//                                                             {row.getVisibleCells().map((cell) => {
//                                                                 return (
//                                                                     <td
//                                                                         className="border p-2 whitespace-nowrap"
//                                                                         key={cell.id}
//                                                                     >
//                                                                         {flexRender(
//                                                                             cell.column.columnDef
//                                                                                 .cell,
//                                                                             cell.getContext()
//                                                                         )}
//                                                                     </td>
//                                                                 );
//                                                             })}
//                                                         </tr>
//                                                     );
//                                                 })} */}
//                                                 {safeVirtualRows.map((virtualRow) => {
//                                                     const row = rows[virtualRow.index];
//                                                     return (
//                                                         <tr key={row.id} className="bg-white transition duration-300 ease-in-out hover:bg-gray-100">
//                                                             {row.getVisibleCells().map((cell) => {
//                                                                 return (
//                                                                     <td
//                                                                         className="border p-2 whitespace-nowrap"
//                                                                         key={cell.id}
//                                                                     >
//                                                                         {flexRender(
//                                                                             cell.column.columnDef
//                                                                                 .cell,
//                                                                             cell.getContext()
//                                                                         )}
//                                                                     </td>
//                                                                 );
//                                                             })}
//                                                         </tr>
//                                                     );
//                                                 })}
//                                                 {paddingBottom > 0 && (
//                                                     <tr>
//                                                         <td
//                                                             className="border p-2"
//                                                             style={{ height: `${paddingBottom}px` }}
//                                                         />
//                                                     </tr>
//                                                 )}
//                                             </>
//                                         )
//                                 }
//                             </tbody>
//                         </table>
//                     </div>
//                 </>
//             )}
//             {data.length > 0 && !startProcess && (
//                 <div className="flex gap-2 justify-start m-3">
//                     <button
//                         type="button"
//                         onClick={downloadFiles}
//                         className="inline-flex justify-center rounded-lg border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
//                     >
//                         <FolderArrowDownIcon className="h-4" title="Download zip file" /> &nbsp;Download
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// }

import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import { DebouncedInput, IndeterminateCheckbox } from "./Filters";
import {
  ArrowDownCircleIcon,
  ArrowDownTrayIcon,
  EyeIcon,
  FolderArrowDownIcon,
} from "@heroicons/react/24/outline";
import ReadModal from "./ReadModal";
import JSZip from "jszip";
import {
  generateFileNameDated,
  generateProcessCodeFileName,
} from "./CommonUtils";

export default function Process({ startProcess, selectedFilesToProcess = [] }) {
  const [isOpenRead, setIsOpenRead] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [data, setData] = useState([]);

  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [rowSelection, setRowSelection] = useState({});

  const tableContainerRef = useRef(null);

  /* ------------------------- DATA NORMALIZATION ------------------------- */
  useEffect(() => {
    const normalized = (selectedFilesToProcess || []).map((f) => ({
      ...f,
      filename: f.filename || f.file_name || f.name || "-",
      status: f.status || "Waiting",
    }));

    setData(normalized);
  }, [selectedFilesToProcess]);

  /* ------------------------- DATE FORMAT ------------------------- */
  const formattedDate = useCallback((dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    const formattedDateString = date
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
    const [month, day, yearAndTime] = formattedDateString.split("/");
    return `${day}-${month}-${yearAndTime}`;
  }, []);

  /* ------------------------- DOWNLOAD ------------------------- */
  const downloadFiles = useCallback(async () => {
    const zip = new JSZip();

    const selectedRows = Object.keys(rowSelection)
      .filter((k) => rowSelection[k])
      .map((k) => data[k]);

    const filesToZip = selectedRows.length ? selectedRows : data;

    filesToZip.forEach((file) => {
      if (file.response) {
        zip.file(
          `${generateFileNameDated(
            file.filename,
            file.creation_date
          )}.json`,
          JSON.stringify(file.response)
        );
      }
    });

    const blob = await zip.generateAsync({ type: "blob" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${sessionStorage.getItem(
      "processName"
    )}_${sessionStorage.getItem("projectName")}.zip`;
    link.click();
  }, [data, rowSelection]);

  /* ------------------------- COLUMNS ------------------------- */
  const columns = useMemo(
    () => [
      {
        id: "select",
        size: 10,
        header: ({ table }) => (
          <IndeterminateCheckbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
          />
        ),
        cell: ({ row }) => (
          <center>
            <IndeterminateCheckbox
              checked={row.getIsSelected()}
              onChange={row.getToggleSelectedHandler()}
            />
          </center>
        ),
      },
      {
        id: "index",
        header: "#",
        size: 50,
        cell: ({ row }) => <center>{row.index + 1}</center>,
      },
      {
        id: "filename",
        header: "File Name",
        accessorFn: (row) => row.filename,
        size: 600,
      },
      {
        accessorKey: "start_date_time",
        header: "Start Date",
        size: 150,
        // cell: ({ row }) => formattedDate(row.original.start_date_time),
        cell: ({ row }) => row.original.start_date_time,
      },
      {
        accessorKey: "creation_date",
        header: "Execution Date",
        size: 150,
        cell: ({ row }) => formattedDate(row.original.creation_date),
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 100,
        cell: ({ row }) => (
          <div className="flex justify-center">
            <span className="px-2 py-1 text-xs font-bold rounded bg-blue-500 text-white">
              {row.original.status}
            </span>
          </div>
        ),
      },
      {
        id: "actions",
        header: "Actions",
        size: 120,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-center">
            <button
              disabled={!row.original.response}
              onClick={() => {
                setRowData(row.original);
                setModalTitle(`Response of ${row.original.filename}`);
                setIsOpenRead(true);
              }}
            >
              <EyeIcon className="h-5" />
            </button>
          </div>
        ),
      },
    ],
    [formattedDate]
  );

  /* ------------------------- TABLE ------------------------- */
  const table = useReactTable({
    data,
    columns,
    state: { sorting, globalFilter, rowSelection },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const rows = table.getRowModel().rows;

  /* ------------------------- VIRTUALIZATION ------------------------- */
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 45,
    overscan: 10,
  });

  /* 🔥 CRITICAL FIX: re-measure when tab becomes visible */
  useEffect(() => {
    if (tableContainerRef.current) {
      rowVirtualizer.measure();
    }
  }, [rows.length]);

  const virtualRows = rowVirtualizer.getVirtualItems();
  const rowsToRender =
    virtualRows.length > 0
      ? virtualRows.map((v) => rows[v.index])
      : rows;

  /* ------------------------- RENDER ------------------------- */
  return (
    <div className="m-2 border rounded-lg bg-white">
      <ReadModal
        isOpen={isOpenRead}
        closeModal={() => setIsOpenRead(false)}
        title={modalTitle}
        modalInputs={
          <pre className="p-4 text-sm">
            {JSON.stringify(rowData?.response, null, 2)}
          </pre>
        }
      />

      {data.length === 0 && (
        <p className="p-4 text-center">No files in progress</p>
      )}

      {data.length > 0 && (
        <>
          <div className="m-3 flex justify-between">
            <DebouncedInput
              value={globalFilter}
              onChange={(v) => setGlobalFilter(String(v))}
              placeholder="Search..."
            />
          </div>

          <div
            ref={tableContainerRef}
            className="overflow-auto"
          >
            <table className="w-full border-collapse">
              <thead className="bg-gray-200 sticky top-0">
                {table.getHeaderGroups().map((hg) => (
                  <tr key={hg.id}>
                    {hg.headers.map((h) => (
                      <th key={h.id} className="border p-2">
                        {flexRender(
                          h.column.columnDef.header,
                          h.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {rowsToRender.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="border p-2">
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {!startProcess && (
            <div className="m-3">
              <button
                onClick={downloadFiles}
                className="flex gap-2 items-center px-4 py-2 bg-blue-100 rounded"
              >
                <FolderArrowDownIcon className="h-4" />
                Download
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}


